import styled from 'styled-components';
import { DatePicker, Form, Select } from 'antd';
import { useEffect, useState } from 'react';
import accountApis from '../../../../../../services/accountApis';
import Button from '../../../../../../components/Button';
import { IReportVoiceParams } from '../../../../interfaces/apis';
import dayjs from 'dayjs';
import { SMSReportParams } from '../../../../../../services/reportApis';

interface ReportSMSFilterProps {
  params?: SMSReportParams;
  setParams?: (params: SMSReportParams) => void;
  setSummaryParams?: (params: SMSReportParams) => void;
}

const ReportSMSFilter = ({ params, setParams, setSummaryParams }: ReportSMSFilterProps) => {
  const [form] = Form.useForm();
  const [listSalon, setLstSalon] = useState<any[]>([]);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await accountApis.filterSalon(null, null, 1, 10000);

        if (response?.status === 200) {
          setLstSalon(response.data.data.content);
        }
      } catch (error) {}
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (params) {
      form.setFieldsValue({
        startDate: params.startDate ? dayjs(params.startDate) : null,
        endDate: params.endDate ? dayjs(params.endDate) : null,
        shopId: params.shopId || '',
      });
    }
  }, [params]);

  const handleFinish = (values: any) => {
    setParams && setParams({ ...params, ...values });
    setSummaryParams && setSummaryParams(values);
  };

  return (
    <Container>
      <Form layout='vertical' className='styled-form' form={form} onFinish={handleFinish}>
        <Form.Item name='startDate' noStyle>
          <DatePicker style={{ width: '20%' }} format='MM-DD-YYYY' showTime={false} placeholder='Start date' />
        </Form.Item>
        <Form.Item name='endDate' noStyle>
          <DatePicker style={{ width: '20%' }} format='MM-DD-YYYY' showTime={false} placeholder='End date' />
        </Form.Item>
        <Form.Item name='shopId' noStyle>
          <Select
            size='large'
            defaultValue={''}
            showSearch
            optionFilterProp='label'
            className='filter-select'
            style={{ flex: 1 }}
          >
            <Select.Option value={''} label={'All Salon - Zipcode'}>
              All Salon - Zipcode
            </Select.Option>
            {listSalon.map((item: any) => (
              <Select.Option key={item.shopId} value={item.shopId} label={`${item.shopName} - ${item.zipCode}`}>
                {item.shopName} - {item.zipCode}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Button variant='SECONDARY' className='styled-button' htmlType='submit'>
          Search
        </Button>
      </Form>
    </Container>
  );
};

export default ReportSMSFilter;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

    .styled-form {
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: 100%;

    .ant-form-item {
      margin-bottom: 0;
    }

    .filter-select {
      width: 200px;
      height: 48px;
    }

    .styled-button {
      height: 48px;
    }
`;